import axios from 'axios'
var root=process.env.API_ROOT;
var qs = require("qs");

export const AxiosPost = (url,params) => {
    return axios.post(root+url,qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const  AxiosGet = (url,params) => {
    return axios.get(root+url,qs.stringify(params));
}

Date.prototype.format = function (format) {
    var date = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S+": this.getMilliseconds()
    };
    if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in date) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1
                            ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
        }
    }
    return format;
}


// WEBPACK FOOTER //
// ./src/api/common/common.js